import { openDB } from 'idb';

class DbUtils {

    static getDb(DB_NAME, VERSION, STORE_NAME) {
        return openDB(DB_NAME, VERSION, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    const store = db.createObjectStore(STORE_NAME, { keyPath: 'id' });
                    store.createIndex('updatedAt', 'updatedAt');
                }
            },
        });
    }


    static async clearAllAndSaveItem(items, DB_NAME, VERSION, STORE_NAME) {
        console.log("Pulisco completamente lo store e salvo nuovi prodotti");
        const db = await this.getDb(DB_NAME, VERSION, STORE_NAME);

        // Prima creiamo una transazione per pulire tutto lo store
        const clearTx = db.transaction(STORE_NAME, 'readwrite');
        await clearTx.store.clear(); // Questa riga pulisce completamente lo store
        await clearTx.done;

        // Poi creiamo una nuova transazione per salvare i prodotti
        const saveTx = db.transaction(STORE_NAME, 'readwrite');
        for (const item of items) {
            await saveTx.store.put(item);
        }
        await saveTx.done;

        console.log(`Store pulito e ${items.length} nuovi items salvati`);
    }

    static async saveItem(items, DB_NAME, VERSION, STORE_NAME) {
        const db = await this.getDb(DB_NAME, VERSION, STORE_NAME);
        const tx = db.transaction(STORE_NAME, 'readwrite');
        for (const item of items) {
            await tx.store.put(item);
        }
        await tx.done;
    }

    static async getAll(DB_NAME, VERSION, STORE_NAME) {
        const db = await this.getDb(DB_NAME, VERSION, STORE_NAME);
        return db.getAll(STORE_NAME);
    }

    static async getItem(id, DB_NAME, VERSION, STORE_NAME) {
        const db = await this.getDb(DB_NAME, VERSION, STORE_NAME);
        return db.get(STORE_NAME, id);
    }

    static async clearAll(DB_NAME, VERSION, STORE_NAME) {
        const db = await this.getDb(DB_NAME, VERSION, STORE_NAME);
        return db.clear(STORE_NAME);
    }


    static mergeItems(cachedItems, updatedItems) {
        const itemMap = new Map(cachedItems.map(p => [p.documentId, p]));
    
        for (let updated of updatedItems) {
            itemMap.set(updated.documentId, updated);
        }
    
        return Array.from(itemMap.values());
    }
}

export default DbUtils;